/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserCouponAvailablePageRespVo } from './GetUserCouponAvailablePageRespVo';
import {
    GetUserCouponAvailablePageRespVoFromJSON,
    GetUserCouponAvailablePageRespVoFromJSONTyped,
    GetUserCouponAvailablePageRespVoToJSON,
    GetUserCouponAvailablePageRespVoToJSONTyped,
} from './GetUserCouponAvailablePageRespVo';

/**
 * 
 * @export
 * @interface PageDataGetUserCouponAvailablePageRespVo
 */
export interface PageDataGetUserCouponAvailablePageRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetUserCouponAvailablePageRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetUserCouponAvailablePageRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetUserCouponAvailablePageRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetUserCouponAvailablePageRespVo>}
     * @memberof PageDataGetUserCouponAvailablePageRespVo
     */
    records?: Array<GetUserCouponAvailablePageRespVo>;
}

/**
 * Check if a given object implements the PageDataGetUserCouponAvailablePageRespVo interface.
 */
export function instanceOfPageDataGetUserCouponAvailablePageRespVo(value: object): value is PageDataGetUserCouponAvailablePageRespVo {
    return true;
}

export function PageDataGetUserCouponAvailablePageRespVoFromJSON(json: any): PageDataGetUserCouponAvailablePageRespVo {
    return PageDataGetUserCouponAvailablePageRespVoFromJSONTyped(json, false);
}

export function PageDataGetUserCouponAvailablePageRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetUserCouponAvailablePageRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetUserCouponAvailablePageRespVoFromJSON)),
    };
}

export function PageDataGetUserCouponAvailablePageRespVoToJSON(json: any): PageDataGetUserCouponAvailablePageRespVo {
    return PageDataGetUserCouponAvailablePageRespVoToJSONTyped(json, false);
}

export function PageDataGetUserCouponAvailablePageRespVoToJSONTyped(value?: PageDataGetUserCouponAvailablePageRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetUserCouponAvailablePageRespVoToJSON)),
    };
}

